define('plugin/client-login/view/ClientLoginRemindPasswordView',['require','lib/view/FormView'],function (require) {

    var FormView = require('lib/view/FormView');

    /**
     * Client remind password
     *
     * @class ClientLoginRemindPasswordView
     */
    return FormView.extend({

        template: '#client_login_remind_password',
        ui: {
            'remind_btn': '#sb_remind_btn',
            'back_btn': '#sb_remind_btn_back',
            'inputs': ':input'
        },
        triggers: {
            'click @ui.remind_btn': 'remind'
        },
        // Was onclick="window.history.back();" in the template -- an inline event handler
        // attribute, which CSP's script-src gates the same as inline <script> execution but with
        // no nonce mechanism to allow it (CY1SDEV1-3837 dropped 'unsafe-inline'). The directory
        // theme's variant of this button uses data-dismiss="modal" instead (Bootstrap's own
        // modal-dismiss binding) rather than history.back(), so skip when that's present to avoid
        // double behavior there.
        events: {
            'click @ui.back_btn': 'onBackClick'
        },
        modelEvents: {
            'invalid': 'render'
        },

        onBackClick: function () {
            if (this.ui.back_btn.attr('data-dismiss')) {
                return;
            }
            window.history.back();
        },

        getDataToRemind: function () {
            return this._getData(this.ui.inputs);
        },

        serializeData: function () {
            return _.extend({
                'is_modal': this.getOption('isModal')
            }, this._serializeData());
        }

    });

});
